/* API related constants */

import { type DownloadFileResponse } from './types'
import { ApiUtil } from './api-utils'

const ADMIN_REPORTS_API_PATH = '/admin/reports'
const ADMIN_ACTIVE_REPORTS_API_PATH = `${ADMIN_REPORTS_API_PATH}/active_meters`

/* Export(s) */
export const AdminReportsApi = {
  downloadActiveMetersReport
}

export type AdminReportsApiType = typeof AdminReportsApi

/* API methods */

/**
 * Download active meters report (admin API).
 * @param token Access token.
 */
async function downloadActiveMetersReport(token: string): Promise<DownloadFileResponse> {
  const apiDesc = 'download active meters report request'
  const url = ApiUtil.getApiUrl(ADMIN_ACTIVE_REPORTS_API_PATH)

  return await ApiUtil.downloadCsvFile({ url, token, apiDesc })
}
